import React from "react";

const TECH_SIGNALS = [
  { k: "AI", t: "AI workflows", d: "Assistants, RAG, automation" },
  { k: "SaaS", t: "Product systems", d: "Dashboards, roles, workflows" },
  { k: "API", t: "Connected data", d: "CRM, booking, payment" },
  { k: "APP", t: "Web + mobile", d: "Apps, platforms, admin tools" },
];

function HomeTechSignal() {
  return (
    <section className="home-tech-signal" aria-label="Technology capabilities">
      <div className="container">
        <div className="home-tech-panel">
          <div className="home-tech-copy">
            <div className="mono home-tech-kicker">TECHNOLOGY PARTNER · AI / PRODUCT / SYSTEMS</div>
            <h2>
              From idea to{" "}
              <span className="serif">working software.</span>
            </h2>
          </div>
          <div className="home-tech-grid">
            {TECH_SIGNALS.map((item, i) => (
              <div className="home-tech-card" key={item.k} style={{ "--delay": `${i * 80}ms` }}>
                <div className="home-tech-card-top">
                  <span className="mono home-tech-key">{item.k}</span>
                  <span className="home-tech-pulse" aria-hidden="true" />
                </div>
                <strong>{item.t}</strong>
                <p>{item.d}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export { HomeTechSignal };
